module.exports = __webpack_public_path__ + "static/media/mew-MAINNET.094f43fe.png";